import { withProps } from 'recompose';

export function addIntlProps({ messages, propNames }) {
  const createProps = ({ intl }) => {
    return propNames.reduce((createdProps, propName) => {
      createdProps[propName] = intl.formatMessage(messages[propName]);
      return createdProps;
    }, {});
  };

  return withProps(createProps);
}
